import { ONBOARDING_COMPLETE_PROGRESS } from "@/api/types";

function storageKey(userId: string): string {
  return `memoru_onboarding_complete:${userId}`;
}

export function markOnboardingComplete(userId: string) {
  try {
    window.localStorage.setItem(storageKey(userId), "1");
  } catch {
    // Home is still reachable for this tab when storage is unavailable.
  }
}

export function hasCompletedOnboarding(userId: string | undefined, progress: number): boolean {
  if (progress >= ONBOARDING_COMPLETE_PROGRESS) return true;
  if (!userId) return false;
  try {
    return window.localStorage.getItem(storageKey(userId)) === "1";
  } catch {
    return false;
  }
}
